import { format } from 'date-fns'

export const defaultDateFormat = 'MMM dd, yyyy'
export const defaultDateTimeFormat = 'MMM dd, yyyy HH:mm:ss'
export const dateToServer = value => format(new Date(value), 'yyyy-MM-dd') + 'T' + format(new Date(value), 'HH:mm')
